import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFloralinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M32 43c7.732 0 14-2.598 14-11.65C46 22.3 39.5 20.936 44 7c-16 3.484-26 15.3-26 24.35C18 40.403 24.268 43 32 43z",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", { d: "M20.5 23c2-3 2-8-.26-13 3.173.333 6.26 1.5 9.26 3.5" }),
			/* @__PURE__ */ _jsx("path", {
				d: "M32 43v18",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", { d: "M38 43c0 2.667 1 5 3 7-4.333 0-7.333-1.667-9-5m-6-2c0 2.667-1 5-3 7 4.333 0 7.333-1.667 9-5m-6-33.5c2-3.333 4.667-5.833 8-7.5 0 2 .5 4 1.5 6" })
		]
	})
});
export default SvgFloralinline;
